import * as client_hooks from '../../../src/hooks.client.js';


export { matchers } from './matchers.js';

export const nodes = [
	() => import('./nodes/0'),
	() => import('./nodes/1'),
	() => import('./nodes/2'),
	() => import('./nodes/3'),
	() => import('./nodes/4'),
	() => import('./nodes/5'),
	() => import('./nodes/6'),
	() => import('./nodes/7'),
	() => import('./nodes/8'),
	() => import('./nodes/9'),
	() => import('./nodes/10'),
	() => import('./nodes/11'),
	() => import('./nodes/12'),
	() => import('./nodes/13'),
	() => import('./nodes/14'),
	() => import('./nodes/15'),
	() => import('./nodes/16'),
	() => import('./nodes/17'),
	() => import('./nodes/18'),
	() => import('./nodes/19'),
	() => import('./nodes/20'),
	() => import('./nodes/21'),
	() => import('./nodes/22'),
	() => import('./nodes/23'),
	() => import('./nodes/24'),
	() => import('./nodes/25'),
	() => import('./nodes/26'),
	() => import('./nodes/27'),
	() => import('./nodes/28'),
	() => import('./nodes/29'),
	() => import('./nodes/30'),
	() => import('./nodes/31'),
	() => import('./nodes/32'),
	() => import('./nodes/33'),
	() => import('./nodes/34'),
	() => import('./nodes/35'),
	() => import('./nodes/36'),
	() => import('./nodes/37'),
	() => import('./nodes/38'),
	() => import('./nodes/39'),
	() => import('./nodes/40'),
	() => import('./nodes/41'),
	() => import('./nodes/42'),
	() => import('./nodes/43'),
	() => import('./nodes/44'),
	() => import('./nodes/45'),
	() => import('./nodes/46'),
	() => import('./nodes/47'),
	() => import('./nodes/48'),
	() => import('./nodes/49'),
	() => import('./nodes/50'),
	() => import('./nodes/51'),
	() => import('./nodes/52'),
	() => import('./nodes/53'),
	() => import('./nodes/54'),
	() => import('./nodes/55'),
	() => import('./nodes/56'),
	() => import('./nodes/57'),
	() => import('./nodes/58'),
	() => import('./nodes/59'),
	() => import('./nodes/60'),
	() => import('./nodes/61'),
	() => import('./nodes/62'),
	() => import('./nodes/63'),
	() => import('./nodes/64'),
	() => import('./nodes/65'),
	() => import('./nodes/66'),
	() => import('./nodes/67'),
	() => import('./nodes/68'),
	() => import('./nodes/69'),
	() => import('./nodes/70'),
	() => import('./nodes/71'),
	() => import('./nodes/72'),
	() => import('./nodes/73'),
	() => import('./nodes/74'),
	() => import('./nodes/75'),
	() => import('./nodes/76'),
	() => import('./nodes/77'),
	() => import('./nodes/78'),
	() => import('./nodes/79'),
	() => import('./nodes/80'),
	() => import('./nodes/81'),
	() => import('./nodes/82'),
	() => import('./nodes/83'),
	() => import('./nodes/84'),
	() => import('./nodes/85'),
	() => import('./nodes/86'),
	() => import('./nodes/87'),
	() => import('./nodes/88'),
	() => import('./nodes/89'),
	() => import('./nodes/90'),
	() => import('./nodes/91'),
	() => import('./nodes/92')
];

export const server_loads = [];

export const dictionary = {
		"/(app)": [12,[2]],
		"/(app)/activity": [13,[2,3]],
		"/(app)/admin": [14,[2,4]],
		"/(app)/admin/analytics": [15,[2,4]],
		"/(app)/admin/analytics/[tab]": [16,[2,4]],
		"/(app)/admin/approvals": [17,[2,4]],
		"/(app)/admin/billing": [18,[2,4]],
		"/(app)/admin/evaluations": [19,[2,4]],
		"/(app)/admin/evaluations/[tab]": [20,[2,4]],
		"/(app)/admin/functions": [21,[2,4]],
		"/(app)/admin/functions/create": [22,[2,4]],
		"/(app)/admin/functions/edit": [23,[2,4]],
		"/(app)/admin/organizations": [24,[2,4]],
		"/(app)/admin/settings": [25,[2,4]],
		"/(app)/admin/settings/[tab]": [26,[2,4]],
		"/(app)/admin/users": [27,[2,4]],
		"/(app)/admin/users/[tab]": [28,[2,4]],
		"/(app)/artifacts": [29,[2]],
		"/(app)/artifacts/[id]": [30,[2]],
		"/(app)/assistants": [31,[2,5]],
		"/(app)/assistants/create": [33,[2,5]],
		"/(app)/assistants/templates": [34,[2,5]],
		"/(app)/assistants/[id]": [32,[2,5]],
		"/auth": [81],
		"/auth/forgot-password": [82],
		"/auth/reset-password": [83],
		"/(app)/automations": [35,[2,6]],
		"/(app)/automations/create": [37,[2,6]],
		"/(app)/automations/edit/[id]": [38,[2,6]],
		"/(app)/automations/[id]/runs": [36,[2,6]],
		"/a/[id]": [80],
		"/(app)/billing": [39,[2]],
		"/(app)/channels/[id]": [41,[2]],
		"/(app)/c/[id]": [40,[2]],
		"/error": [84],
		"/explore/agents": [85],
		"/explore/artifacts": [86],
		"/(app)/home": [42,[2,7]],
		"/(app)/integrations": [43,[2]],
		"/invite/[token]": [87],
		"/join/[code]": [88],
		"/(app)/notes": [44,[2,8]],
		"/(app)/notes/new": [46,[2,8]],
		"/(app)/notes/[id]": [45,[2,8]],
		"/(app)/openclaw": [47,[2,9]],
		"/(app)/organizations/new": [48,[2]],
		"/papers/[...doi]": [89],
		"/(app)/playground": [50,[2,10]],
		"/(app)/playground/completions": [51,[2,10]],
		"/(app)/pulse": [52,[2]],
		"/(app)/p/[id]": [49,[2]],
		"/(app)/skills": [53,[2]],
		"/s/[id]": [90],
		"/t/[id]": [91],
		"/watch": [92],
		"/(app)/workspace": [54,[2,11]],
		"/(app)/workspace/activity": [55,[2,11]],
		"/(app)/workspace/assistants": [56,[2,11]],
		"/(app)/workspace/audit": [57,[2,11]],
		"/(app)/workspace/automations": [58,[2,11]],
		"/(app)/workspace/automations/create": [60,[2,11]],
		"/(app)/workspace/automations/edit/[id]": [61,[2,11]],
		"/(app)/workspace/automations/[id]/runs": [59,[2,11]],
		"/(app)/workspace/billing": [62,[2,11]],
		"/(app)/workspace/functions/create": [63,[2,11]],
		"/(app)/workspace/general": [64,[2,11]],
		"/(app)/workspace/knowledge": [65,[2,11]],
		"/(app)/workspace/knowledge/create": [67,[2,11]],
		"/(app)/workspace/knowledge/[id]": [66,[2,11]],
		"/(app)/workspace/members": [68,[2,11]],
		"/(app)/workspace/models": [69,[2,11]],
		"/(app)/workspace/models/create": [70,[2,11]],
		"/(app)/workspace/models/edit": [71,[2,11]],
		"/(app)/workspace/prompts": [72,[2,11]],
		"/(app)/workspace/prompts/create": [73,[2,11]],
		"/(app)/workspace/prompts/edit": [74,[2,11]],
		"/(app)/workspace/shares": [75,[2,11]],
		"/(app)/workspace/skills": [76,[2,11]],
		"/(app)/workspace/tools": [77,[2,11]],
		"/(app)/workspace/tools/create": [78,[2,11]],
		"/(app)/workspace/tools/edit": [79,[2,11]]
	};

export const hooks = {
	handleError: client_hooks.handleError || (({ error }) => { console.error(error) }),
	init: client_hooks.init,
	reroute: (() => {}),
	transport: {}
};

export const decoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.decode]));
export const encoders = Object.fromEntries(Object.entries(hooks.transport).map(([k, v]) => [k, v.encode]));

export const hash = false;

export const decode = (type, value) => decoders[type](value);

export { default as root } from '../root.js';